import { IHost, ISite } from '@/types/models';
import getHostUrl from './getHostUrl';

function getSitUrl(host: IHost, site: ISite) {
  if (site.isSeparatedWeb) return site.separatedWebUrl;
  return getHostUrl(host.hostName, host.nodeName, host.isHongKong) + site.localUrl;
}

export default getSitUrl;
